/* eslint-disable no-useless-escape */
import * as Yup from "yup";
import { formatMoney } from "@utils/helpers/stringHelper";

const createPleaseEnterValueBetweenMessage = (min, max) => `Please enter value between ${min} and ${max}.`

export const createPleaseEnterValueBetweenDollarAmount = 
  (min, max) => `Loan amount must be between ${formatMoney(min)}-${formatMoney(max)}`;

export const requiredFieldMessage = "Field is required";
export const firstNameRequiredMessage = "Please enter your first name";
export const lastNameRequiredMessage = "Please enter your last name";
export const loanAmountRequiredMessage = "Please enter a loan amount";
export const requestedProductTypeRequiredMessage = "Please select a loan type";
export const loanReasonRequiredMessage = "Please select a loan reason";
export const mobilePhoneRequiredMessage = "Please enter your mobile number";
export const emailAddressRequiredMessage = "Please enter your email address";
export const titleRequiredMessage = "Please select a title";
export const birthDayRequiredMessage = "Day required";
export const birthMonthRequiredMessage = "Month required";
export const birthYearRequiredMessage = "Year required";
export const streetNumberRequiredMessage = "Street number required";
export const suburbRequiredMessage = "Suburb required";
export const streetNameRequiredMessage = "Street name required";
export const stateRequiredMessage = "State required";
export const postCodeRequiredMessage = "Postcode required";
export const maritalStatusRequiredMessage = "Please select your marital status";
export const dependentsRequiredMessage = "Please select number of dependents";
export const residentialStatusRequiredMessage = "Please select your residential status";
export const residentialPaymentRequiredMessage = "Please enter your residential payment";
export const foreseeableChangesRequiredMessage = "Please select an option";
export const foreseeableChangesDetailsRequiredMessage = "Please provide details";
export const employmentTypeRequiredMessage = "Please select your employment type";
export const businessNameRequiredMessage = "Please enter your employers name";
export const incomeFrequencyRequiredMessage = "Please select your income frequency";
export const totalIncomeRequiredMessage = "Please enter your total income";
export const startDateMonthRequiredMessage = "Month is required";
export const startDateYearRequiredMessage = "Year is required";
export const bankStatementRequiredMessage = "Please submit bank statement";
export const dobAgeMessage = "Must be 18 years or older"
export const invalidValue = "Please enter a valid value";
export const requiredLetterInputFieldRegexMessage =
  "Value entered must be minimum 2 letters";
export const requiredStreetInputFieldRegexMessage =
  "Please enter a valid street";
export const startWithNumberMessage = "Must start with number";
export const emailInputFieldRegexMessage = "Please enter a valid email address";
export const postCodeLengthMessage = "Post code must be 4 numbers";
export const vehiclePurchaseMaxMessage = "Only vehicle purchase loan reason can be over $10,000";
export const numberBetweenHundredAndTenThousand = createPleaseEnterValueBetweenMessage("100", "10,000");
export const numberBetweenTenAndTenThousand = createPleaseEnterValueBetweenMessage("10", "10,000");
export const requireCheckboxMessage = "Field must be checked";
export const requiredPhoneInputFieldRegexMessage = (numberType = "mobile number") =>
  `Please enter a valid ${numberType} with 10 digits starting with 04.`;
export const requiredLetterInputFieldRegex = /^[A-Za-z '-]+$/;
export const requiredDigitInputFieldRegex = /^[0-9]+$/;
export const requiredDigitOrLetterInputFieldRegex = /^[0-9A-Za-z ]+$/;
export const requiredStreetInputFieldRegex = /^[a-zA-Z0-9 '/-]+([a-zA-Z '/-]+)$/;
export const streetAddressDigitOrLetterInputFieldRegex = /^[a-zA-Z0-9-\/]+( [a-zA-Z0-9-\/]+)*$/;
export const unitNumberDigitOrLetterInputFieldRegex = /^[a-zA-Z0-9-/]*$/;
export const startWithNumberRegex = /(^\d)/;
export const twoCharacterInputFieldRegex = /^[A-Za-z '-]{2,}$/;
export const emailInputFieldRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const digitPhoneInputFieldRegex = /^04\d{8}$/;
export const commonPhoneNumberRegex = /^[0-9\+()]{8,}$/;
export const isDobFieldValid = (dob, today = new Date()) => {
  const { day, month, year } = dob;
  const birthDate = new Date(year, month - 1, day);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age = age - 1;
  }
  return age >= 18;
};
export const identificationTypeProperty = "identificationType";
export const validPhoneNumberMessage = "Please enter a valid Australian phone number."
export const futureDateMessage = "Start date cannot be in the future";
export const getPhoneNumberValidation = (required) => {
  if (required)
    return Yup.string()
      .required(requiredFieldMessage)
      .matches(commonPhoneNumberRegex, {
        message: validPhoneNumberMessage,
        excludeEmptyString: true
      });

  return Yup.string()
    .matches(commonPhoneNumberRegex, {
      message: validPhoneNumberMessage,
      excludeEmptyString: true
    })
};

export const getNameValidation = (required) => {
  if (required)
    return Yup.string()
      .required(requiredFieldMessage)
      .matches(requiredLetterInputFieldRegex, {
        message: invalidValue,
        excludeEmptyString: true,
      })
      .matches(twoCharacterInputFieldRegex, {
        message: requiredLetterInputFieldRegexMessage,
        excludeEmptyString: true,
      });

  return Yup.string()
    .matches(requiredLetterInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    })
    .matches(twoCharacterInputFieldRegex, {
      message: requiredLetterInputFieldRegexMessage,
      excludeEmptyString: true,
    });
}


export const requiredFieldValidation = Yup.string()
  .trim()
  .required(requiredFieldMessage);

export const maxOneMillion = "Maximum of $1,000,000";

export const monthYearNotAfterDate = (date) => function ({month, year}) {
  const dateYear = date.getFullYear();
  const dateMonth = date.getMonth() + 1; // Date is 0 offset in JavaScript
  const parsedYear = parseInt(year);
  const parsedMonth = parseInt(month);
  return parsedYear < dateYear || (parsedYear === dateYear && parsedMonth <= dateMonth);
};

export const monthYearNotAfterCurrentDate = monthYearNotAfterDate(new Date());

export const createRequiredMonthYearShape = () => ({
  month: Yup.string()
    .trim()
    .required(startDateMonthRequiredMessage),
  year: Yup.string()
    .trim()
    .required(startDateYearRequiredMessage),
});